// eslint-disable-next-line no-unused-vars
import { urlMainAPI} from "@/global";
import { mapState } from "vuex";
import axios from "axios";

var taksRotationScreen;

export var rotationScreenMixin = {
  computed: mapState(["rotationScreen", "user"]),

  data() {
    return {
      rotationRouter: {},
      indexRotation: 0
    };
  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    async rotationScreen(value){
      if(value){
        this.indexRotation = 0;
        if(!this.rotationRouter || !this.rotationRouter.routes)
          await this.loadRotationScreen()

        this.activeRotation();

      }else{
        clearTimeout(taksRotationScreen);
      }
    }
  },

  methods: {
    async loadRotationScreen(){
      let system = this.user.role == "GDI" ? "G" : "P";
      let userUnitId = this.user.UnitId;
      let userId = this.user.Id;

      await axios.get(`${urlMainAPI}/getscreenrotationsettings/${system}/${userUnitId}/${userId}`)
        .then( async (res) => {
          if(res.data){
            this.rotationRouter = res.data;
            this.indexRotation = await this.getCurrentIndex();
          }
        })
        .catch(console.log);
    },

    async getCurrentIndex(){
      let url = window.location.href.split("/");
      let parameter = decodeURI(url[url.length - 1]);
      let index = 0;
      await this.rotationRouter.routes.forEach((rout, i) => {
        if(parameter == rout.parameter)
          index = i;
      });
      return index;
    },

    activeRotation(){
      if(!this.rotationScreen || this.rotationRouter.routes.length < 2)
        return;

      console.log("ROTAÇÃO ATIVADA*** " + this.rotationRouter.secondsrotation + " seg.");
      taksRotationScreen = setTimeout(() => {
        let url = window.location.href.split("/");
        let parameter = decodeURI(url[url.length - 1]);
        let path = "";

        if(this.indexRotation == this.rotationRouter.routes.length - 1)
          this.indexRotation = 0
        else
          this.indexRotation += 1;

        path = this.rotationRouter.routes[this.indexRotation].parameter;
        
        if(!this.rotationRouter.routes[this.indexRotation].rotation || path == parameter){
          this.getNextScreen(parameter)
          path = this.rotationRouter.routes[this.indexRotation].parameter;
        }
          
        if(this.rotationRouter.routes[this.indexRotation].cardType == "GDI" || this.rotationRouter.routes[this.indexRotation].cardType == "PGDI")
          this.$router.replace(`/monitoring/${path}`);
        else
          this.$router.replace(`/occurrencemonitoring/${path}`);

        this.activeRotation();
      }, this.rotationRouter.secondsrotation * 1000);
    },

    getNextScreen(parameter){
      this.indexRotation += 1;

      if(this.indexRotation == this.rotationRouter.routes.length)
        this.indexRotation = 0
      
      while(!this.rotationRouter.routes[this.indexRotation].rotation){
        this.indexRotation++;
        if(this.indexRotation == this.rotationRouter.routes.length){
          this.indexRotation = 0
        }
      }

      if(!this.rotationRouter.routes[this.indexRotation].rotation || 
          this.rotationRouter.routes[this.indexRotation].parameter == parameter)
        this.getNextScreen(parameter);
    },

    isRunning(){
      if(!this.rotationRouter.routes)
        return true
      return false
    },

    async startRotation(){
      if(this.isRunning()){
        clearTimeout(taksRotationScreen);
        await this.loadRotationScreen();
        this.activeRotation();
      }
    },

    stopRotation(){
      //console.log("Rotação desativada.")
      clearTimeout(taksRotationScreen);
    }
  },
  destroyed() {
    this.stopRotation();
  },
};
